import { render, staticRenderFns } from "./AttachmentLoader.vue?vue&type=template&id=3e6ddb04"
import script from "./AttachmentLoader.vue?vue&type=script&lang=js"
export * from "./AttachmentLoader.vue?vue&type=script&lang=js"
import style0 from "./AttachmentLoader.vue?vue&type=style&index=0&id=3e6ddb04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports